// =============================================================
// opBNB network definitions.
// NOTE: The active network is selected in app.config.js (NOT here,
// and NOT visible to the user). Both are defined so we can flip in code.
// =============================================================

export const NETWORKS = {
  // opBNB Mainnet
  opbnbMainnet: {
    key: "opbnbMainnet",
    chainId: 204, // 0xcc
    chainIdHex: "0xcc",
    name: "opBNB",
    nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
    rpcUrls: ["https://opbnb-mainnet-rpc.bnbchain.org"],
    blockExplorerUrls: ["https://opbnbscan.com"],
  },

  // opBNB Test network (internal use only — never labeled in the UI)
  opbnbTest: {
    key: "opbnbTest",
    chainId: 5611, // 0x15eb
    chainIdHex: "0x15eb",
    name: "opBNB",
    nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
    rpcUrls: ["https://opbnb-testnet-rpc.bnbchain.org"],
    blockExplorerUrls: ["https://testnet.opbnbscan.com"],
  },
};
